import PropTypes from 'prop-types'
import { useRef, useEffect, useState } from 'react'
import Map from 'ol/Map'
import Zoom from 'ol/control/Zoom'
import Message from '../../elements/message'
import LoadingDots from '../loading-dots'
import { Property } from '../properties'
import useMapResize from '../../../../hooks/use-map-resize'
import MapControls from '../../../map-controls'

export default function ImagesMap({
  onMapInitialized,
  filename,
  indexInfo,
  status,
  info,
  metadata,
  error,
}) {
  const containerRef = useRef()
  const controlRef = useRef()
  const [map, setMap] = useState()

  useEffect(() => {
    const map = new Map({
      target: containerRef.current,
      controls: [new Zoom()],
      layers: [],
    })
    setMap(map)
    onMapInitialized && onMapInitialized(map)
  }, [onMapInitialized])

  useMapResize(map, containerRef.current)

  return (
    <div className="tw-w-full tw-h-full">
      <div className="tw-w-full tw-h-full tw-flex tw-justify-between tw-items-center tw-relative tw-border tw-border-solid tw-border-system-grey-200">
        {status === 'loading' && (
          <Message message="Loading image...">
            <LoadingDots primaryColor />
          </Message>
        )}
        {error && status !== 'loading' && (
          <Message message="This image could unfortunately not be displayed." />
        )}
        <div
          data-testid="detect-image-map"
          ref={containerRef}
          className={`${
            status !== 'loading' && !error ? 'tw-w-full tw-h-full' : 'hidden'
          }`}
        />
        <div
          ref={controlRef}
          className="tw-absolute tw-z-10 tw-top-24 tw-right-4"
        />
        {controlRef.current && map && (
          <MapControls
            map={map}
            container={controlRef.current}
            showGeolocationControl={false}
          />
        )}
        <div className="tw-w-md tw-absolute tw-bottom-0 tw-right-0 tw-z-50 tw-bg-white tw-m-0">
          <div className="tw-py-4 tw-px-6 tw-text-sm ">
            <div className="tw-flex tw-justify-between tw-text-system-grey-400 tw-font-mono">
              <span className="tw-mr-10 tw-font-medium tw-truncate">
                {filename}
              </span>
              <span className="tw-flex-shrink-0">{indexInfo}</span>
            </div>
            {metadata && (
              <div data-testid="images-map-metadata" className="tw-mt-3">
                {metadata.map(data => (
                  <Property
                    key={data.title}
                    title={data.title}
                    value={data.value}
                    unit={data.unit}
                  />
                ))}
              </div>
            )}
          </div>
          {info && (
            <div className="tw-border-0 tw-border-t tw-border-solid tw-border-gray-200 tw-px-6 tw-py-4 tw-text-system-grey-600">
              {info}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

ImagesMap.propTypes = {
  filename: PropTypes.string,
  indexInfo: PropTypes.string,
  onMapInitialized: PropTypes.func,
  status: PropTypes.oneOf(['loading', 'idle']),
  info: PropTypes.node,
  metadata: PropTypes.arrayOf(
    PropTypes.shape({ title: PropTypes.string, value: PropTypes.sting })
  ),
  error: PropTypes.object,
}
